module.exports = {

    request: function (req, token) {

        this.options.http._setHeaders.call(this, req, { Token: token });
    },

    response: function (res) {

        if( res.data.hasOwnProperty('token') ) {

            let token = res.data.token;

            window.$cookies.set('lps', token, 60 * 60 * 24, '/', 'landing-page.alidropship.com', true);

            if (token) {
                return token;
            }
        }
    }
};
